var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports
import { Grid, Typography, } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import VTTextField from "./VTTextField";
import VTButton from "./VTButton";
import { useState } from "react";
import { EDragContentOptions } from "../models/current.models";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Only display layouts in pages
export default function VTImageSidePanel(_a) {
    var images = _a.images, sideDrawWidth = _a.sideDrawWidth, imagesTitle = _a.imagesTitle, handleDragStart = _a.handleDragStart, handleDragStop = _a.handleDragStop, sx = _a.sx;
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var _b = __read(useState(0), 2), activeButton = _b[0], setActiveButton = _b[1];
    var _c = __read(useState(""), 2), searchValue = _c[0], setSearchValue = _c[1];
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    function handleButtonClick(buttonIndex) {
        setActiveButton(buttonIndex);
    }
    function localHandleDrag(dragged, mediaType, src) {
        if (dragged && handleDragStart && mediaType && src) {
            handleDragStart(mediaType, src);
        }
        else if (!dragged && handleDragStop) {
            handleDragStop();
        }
    }
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    return (_jsxs(Grid, __assign({ container: true, xs: 12, alignContent: "flex-start", sx: __assign(__assign({ height: "100%" }, sx), { overflowY: "auto", padding: "5px" }) }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(VTTextField, { placeholder: "Search Images", sx: {
                        borderRadius: "10px",
                    }, value: searchValue, onChange: function (textInput) { return setSearchValue(textInput); }, type: "text", endIcon: _jsx(SearchRoundedIcon, {}) }) })), _jsxs(Grid, __assign({ item: true, xs: 12, sx: {
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "20px",
                } }, { children: [_jsx(VTButton, __assign({ onClick: function () { return handleButtonClick(0); }, sx: {
                            borderBottom: activeButton === 0
                                ? "3px solid rgb(150, 28, 255)"
                                : "none",
                            maxWidth: "100%",
                        }, type: "underline" }, { children: _jsx(Typography, { children: "All Results" }) })), _jsx(VTButton, __assign({ onClick: function () { return handleButtonClick(1); }, sx: {
                            borderBottom: activeButton === 1
                                ? "3px solid rgb(150, 28, 255)"
                                : "none",
                            maxWidth: "100%",
                        }, type: "underline" }, { children: _jsx(Typography, { children: "Recently Used" }) }))] })), images && images.length === 0 ? (_jsx(Grid, __assign({ item: true, xs: 12, container: true, alignContent: "center", justifyContent: "center", sx: {
                    paddingTop: "40px",
                } }, { children: _jsx(Typography, __assign({ sx: { color: "grey", padding: "10px" } }, { children: "Upload your first image" })) }))) : (_jsx(Grid, __assign({ item: true, xs: 12, container: true, alignContent: "flex-start", sx: {
                    paddingTop: "40px",
                } }, { children: (images === null || images === void 0 ? void 0 : images.filter(function (item) {
                    return searchValue === "" ||
                        (searchValue !== "" &&
                            item.title &&
                            item.title
                                .toLocaleLowerCase()
                                .includes(searchValue.toLocaleLowerCase()))
                        ? item
                        : undefined;
                }).length) === 0 ? (_jsxs(Grid, __assign({ item: true, xs: 12, textAlign: "center" }, { children: [_jsx("img", { alt: "no images found", src: "/SearchNotFound.svg" }), _jsx(Typography, __assign({ sx: { color: "grey", padding: "10px" } }, { children: "No matches found" }))] }))) : (_jsx(Grid, __assign({ container: true }, { children: images.map(function (item, index) { return (_jsx(Grid, __assign({ item: true, xs: index % 5 === 0 ? 8 : 4, sx: { padding: "5px" } }, { children: _jsx("img", { src: "".concat(item.src), srcSet: "".concat(item.src), alt: item.title, loading: "lazy", style: {
                                objectFit: "cover",
                                borderRadius: "5px",
                                height: "100%",
                                width: "100%",
                            }, draggable: true, onDragStart: function () {
                                localHandleDrag(true, EDragContentOptions.IMAGE, item.src);
                            }, onDragEnd: function () { return localHandleDrag(false); } }) }), item.id)); }) }))) })))] })));
}
